import { render, staticRenderFns } from "./yesIframe.vue?vue&type=template&id=45c1daf5"
import script from "./yesIframe.vue?vue&type=script&lang=js"
export * from "./yesIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports